import { Component, input } from '@angular/core';
import { DsCheckboxModule, DsFormFieldModule, DsLabelModule, DsMessageModule } from '@bmw-ds/components';

import { LoadingIndicatorComponent } from '../../../loading/loading-indicator.component';
import { ConsentCheckboxGroup, ConsentSelection } from '../../model/consent-checkbox';
import { LegalTextComponent } from '../legal-text/legal-text.component';

@Component({
  selector: 'cdf-consent-readonly',
  imports: [
    DsCheckboxModule,
    DsLabelModule,
    DsMessageModule,
    DsFormFieldModule,
    LoadingIndicatorComponent,
    LegalTextComponent,
  ],
  template: `
    <ds-message
      tone="info"
      variant="slim"
      [isVisible]="infoMessageText().length > 0"
      [isDismissable]="false"
      [messageText]="infoMessageText()"
    />
    @if (consentCheckboxGroups()?.length === 0) {
      <cdf-loading-indicator />
    }
    <table>
      <tbody>
        <!-- multiple checkboxes per group -->
        @for (checkboxGroup of consentCheckboxGroups(); track groupIndex; let groupIndex = $index) {
          <tr>
            <td class="expand">
              @for (checkbox of checkboxGroup.checkboxes; track checkbox.key) {
                <ds-form-field>
                  <ds-checkbox-group>
                    <input
                      ds-input
                      [id]="consentInputId(checkbox.key)"
                      type="checkbox"
                      [checked]="consentSelection()?.[checkbox.key]"
                      readonly
                    />
                    <label ds-label [for]="consentInputId(checkbox.key)">
                      @if (checkboxGroup.checkboxes.length === 1 && checkboxGroup.headline) {
                        <cdf-legal-text [legalText]="checkboxGroup.headline" />
                      } @else {
                        {{ checkbox.label }}
                      }
                    </label>
                  </ds-checkbox-group>
                </ds-form-field>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  `,
  styleUrl: 'consent-readonly.component.scss',
})
export class ConsentReadonlyComponent {
  readonly infoMessageText = input<string>('');
  readonly consentCheckboxGroups = input.required<ConsentCheckboxGroup[] | undefined>();
  readonly consentSelection = input.required<ConsentSelection | undefined>();

  protected consentInputId(id: string): string {
    return `cdf-consent-readonly-input-${id}`;
  }
}
